import { AxiosResponseHeaders } from 'axios';
import { ForecastResponseDTO } from '../entities';

const forecastDTOToForecastAdapter = (data: ForecastResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { forecastDTOToForecastAdapter };
